const WORKSPACE_KEY = "tk-master:tiktok-oauth-workspace";
const RETURN_TOKEN_KEY = "tk-master:tiktok-oauth-return-token";

function canUseSessionStorage(): boolean {
  return typeof sessionStorage !== "undefined";
}

/** 记录本次 OAuth 流程的 workspace 与唯一回跳 token。 */
export function beginTikTokOAuthFlow(workspaceId: string): void {
  if (!canUseSessionStorage()) return;
  sessionStorage.setItem(WORKSPACE_KEY, workspaceId);
  sessionStorage.setItem(
    RETURN_TOKEN_KEY,
    globalThis.crypto?.randomUUID?.() ??
      `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`,
  );
}

export function readTikTokOAuthWorkspace(): string | null {
  if (!canUseSessionStorage()) return null;
  return sessionStorage.getItem(WORKSPACE_KEY);
}

export function readTikTokOAuthReturnToken(): string | null {
  if (!canUseSessionStorage()) return null;
  return sessionStorage.getItem(RETURN_TOKEN_KEY);
}

export function clearTikTokOAuthFlow(): void {
  if (!canUseSessionStorage()) return;
  sessionStorage.removeItem(WORKSPACE_KEY);
  sessionStorage.removeItem(RETURN_TOKEN_KEY);
}
